module.exports = __webpack_public_path__ + "static/media/artist_nord-z_b.1ec31ec9.png";